import BaseController from "controllers/backend/base"

import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"
import { ajax } from "jquery"

class Controller extends BaseController {
  call() {
    super.call()

    bindResultsFilter.call(this)
    bindreReimportButton.call(this)
  }
};

const bindResultsFilter = function() {
  let elem = this.root
  this.resultsFilter = new ResultsFilterWidget(elem)
}

var bindreReimportButton = function() {
  this.root.on('.import-vehicle-dump').on("click", (e) => {
    if (e.target.classList.contains("import-vehicle-dump")) {
      e.preventDefault();
      e.stopPropagation();
      const loadForm = this.resultsFilter
      const root = this.root;
      const $element = $(e.target)
      $.ajax({
        url: $element.attr("href"),
        method: "get",
        beforeSend: function(){
          root.find('.loading-spinner').show()
        },
        success: function(response){
          const { record:{ LOTSKU, last_error } } = response
          if (response.import_success) {
            swal({
              type: "success",
              title: `${LOTSKU} imported`
            })
          } else {
            swal({
              type: "error",
              title: `${LOTSKU} not imported`,
              text: last_error
            })
          }
          loadForm.freshData()
        },
        error: function(error){
          swal({
            type: "error",
            title: "Something went wrong",
            text: "Please try again later"
          })
          loadForm.freshData()
        }
      })
    }
  })
}

export default Controller;
